import React from "react";
import BaseModal from "../BaseModal/index.tsx";
import CadastroTipoCirurgia from "../../CadastroTipoCirurgia/index.tsx";

const CadastroTipoCirurgiaModal = ({ isOpen, onClose, onAdd }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      title="Cadastro de Tipo de cirurgia"
      onClose={onClose}
    >
      <CadastroTipoCirurgia onAdd={onAdd} />
    </BaseModal>
  );
};

export default CadastroTipoCirurgiaModal;
